function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("rect", {
  fill: "#bef0fc",
  height: 18.858,
  rx: 4.066,
  width: 56.975,
  x: 99.513,
  y: 71.203
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m183.855 162.146-32.891-32.892a19.434 19.434 0 0 1 -5.692-13.741v-25.452h-34.544v25.452a19.434 19.434 0 0 1 -5.692 13.741l-32.891 32.892a35.646 35.646 0 0 0 0 50.264l30.723 30.723a35.646 35.646 0 0 0 50.264 0l30.723-30.723a35.646 35.646 0 0 0 0-50.264z",
  fill: "#9be5f9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m155.837 46.562a6.948 6.948 0 0 1 -.618-4.977 27.726 27.726 0 0 0 .894-6.972 28.116 28.116 0 1 0 -55.345 7 6.968 6.968 0 0 1 -.613 4.962 11.027 11.027 0 0 0 9.545 16.035 2.544 2.544 0 0 1 2.556 2.507v.183a6.286 6.286 0 0 0 4.144 5.9h23.2a6.286 6.286 0 0 0 4.146-5.907v-.179a2.544 2.544 0 0 1 2.554-2.504 10.983 10.983 0 0 0 9.538-16.048z",
  fill: "#edf4fc"
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 116.054,
  cy: 38.713,
  fill: "#fc657e",
  rx: 5.622,
  ry: 6.324
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 139.946,
  cy: 38.713,
  fill: "#fc657e",
  rx: 5.622,
  ry: 6.324
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m117.144 90.061 4.591 25.764a2.785 2.785 0 0 0 2.742 2.3h7.046a2.785 2.785 0 0 0 2.742-2.3l4.591-25.764z",
  fill: "#b77035"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m127.5 178c-29.661-19.628-57.585-5.011-64.231-.96a35.633 35.633 0 0 0 8.876 35.37l30.723 30.723a35.646 35.646 0 0 0 50.264 0l30.723-30.723a35.607 35.607 0 0 0 9.318-33.743c-5.837 3.562-35.241 19.472-65.673-.667z",
  fill: "#87d147"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  fill: "#b2e26d"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 169,
  r: 6.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 200,
  r: 10.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137.5,
  cy: 151.5,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 212,
  r: 5.5
}));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m132.1 56.617a2.5 2.5 0 0 1 -2.238-1.382l-1.862-3.735-1.866 3.732a2.5 2.5 0 1 1 -4.472-2.232l2.152-4.3a4.68 4.68 0 0 1 8.372 0l2.152 4.3a2.5 2.5 0 0 1 -2.234 3.618z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m122.378 73.7a2.5 2.5 0 0 1 -2.5-2.5v-6.869a2.5 2.5 0 0 1 5 0v6.869a2.5 2.5 0 0 1 -2.5 2.5z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m133.622 73.7a2.5 2.5 0 0 1 -2.5-2.5v-6.869a2.5 2.5 0 0 1 5 0v6.869a2.5 2.5 0 0 1 -2.5 2.5z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m152.421 92.561h-48.842a6.573 6.573 0 0 1 -6.566-6.561v-10.731a6.573 6.573 0 0 1 6.566-6.566h48.842a6.573 6.573 0 0 1 6.566 6.566v10.731a6.573 6.573 0 0 1 -6.566 6.561zm-48.842-18.861a1.567 1.567 0 0 0 -1.566 1.566v10.734a1.568 1.568 0 0 0 1.566 1.566h48.842a1.568 1.568 0 0 0 1.566-1.566v-10.731a1.567 1.567 0 0 0 -1.566-1.566z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m128 256.025a37.924 37.924 0 0 1 -26.9-11.125l-30.723-30.722a38.085 38.085 0 0 1 0-53.8l32.892-32.891a16.823 16.823 0 0 0 4.959-11.974v-25.452a2.5 2.5 0 0 1 2.5-2.5h34.544a2.5 2.5 0 0 1 2.5 2.5v25.452a16.823 16.823 0 0 0 4.959 11.974l32.892 32.891a38.085 38.085 0 0 1 0 53.8l-30.723 30.722a37.924 37.924 0 0 1 -26.9 11.125zm-14.772-163.464v22.952a21.788 21.788 0 0 1 -6.424 15.509l-32.891 32.891a33.081 33.081 0 0 0 0 46.73l30.722 30.723a33.083 33.083 0 0 0 46.73 0l30.722-30.723a33.08 33.08 0 0 0 0-46.73l-32.887-32.891a21.788 21.788 0 0 1 -6.424-15.509v-22.952z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m139.6 73.7h-23.2a2.508 2.508 0 0 1 -.853-.15 8.813 8.813 0 0 1 -5.793-8.257v-.173c-.006.009-.044-.012-.109-.013a13.58 13.58 0 0 1 -5.313-1.23 13.449 13.449 0 0 1 -6.4-18.455 4.447 4.447 0 0 0 .41-3.19 30.615 30.615 0 1 1 60.267-7.622 30.309 30.309 0 0 1 -.974 7.6 4.426 4.426 0 0 0 .415 3.194 13.529 13.529 0 0 1 -11.7 19.7.182.182 0 0 0 -.123.038l.013.148a8.813 8.813 0 0 1 -5.793 8.257 2.508 2.508 0 0 1 -.847.153zm-22.7-5h22.2a3.8 3.8 0 0 0 2.144-3.407v-.179a5.025 5.025 0 0 1 5-5.006 8.609 8.609 0 0 0 3.357-.786 8.451 8.451 0 0 0 4.017-11.609 9.474 9.474 0 0 1 -.821-6.759 25.286 25.286 0 0 0 .814-6.344 25.615 25.615 0 1 0 -50.424 6.38 9.5 9.5 0 0 1 -.814 6.734 8.447 8.447 0 0 0 4.019 11.6 8.605 8.605 0 0 0 3.361.788 5.025 5.025 0 0 1 5 5.006v.182a3.8 3.8 0 0 0 2.147 3.4z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "m93.941 5.487h-2.33v-2.33a3.158 3.158 0 0 0 -6.315 0v2.33h-2.329a3.158 3.158 0 0 0 0 6.315h2.333v2.33a3.158 3.158 0 0 0 6.315 0v-2.332h2.33a3.158 3.158 0 0 0 0-6.315z",
  fill: "#ef4460"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "m195.705 133.654a11.1 11.1 0 0 1 -8.9-8.717.2.2 0 0 0 -.395 0 11.1 11.1 0 0 1 -8.9 8.717.2.2 0 0 0 0 .386 11.1 11.1 0 0 1 8.9 8.717.2.2 0 0 0 .395 0 11.1 11.1 0 0 1 8.9-8.717.2.2 0 0 0 0-.386z",
  fill: "#f5c84c"
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  cx: 174.662,
  cy: 110.494,
  fill: "#87d147",
  r: 3.377
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  cx: 71.662,
  cy: 144.494,
  fill: "#70d6f9",
  r: 3.377
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  cx: 78.662,
  cy: 34.494,
  fill: "#f5c84c",
  r: 3.377
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "m116.054 47.538c-4.478 0-8.121-3.959-8.121-8.825s3.643-8.824 8.121-8.824 8.122 3.959 8.122 8.824-3.644 8.825-8.122 8.825zm0-12.649c-1.721 0-3.121 1.715-3.121 3.824s1.4 3.825 3.121 3.825 3.122-1.716 3.122-3.825-1.401-3.824-3.122-3.824z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "m139.946 47.538c-4.478 0-8.122-3.959-8.122-8.825s3.644-8.824 8.122-8.824 8.121 3.959 8.121 8.824-3.643 8.825-8.121 8.825zm0-12.649c-1.721 0-3.122 1.715-3.122 3.824s1.4 3.825 3.122 3.825 3.121-1.716 3.121-3.825-1.4-3.824-3.121-3.824z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "m131.523 120.622h-7.046a5.282 5.282 0 0 1 -5.2-4.357l-4.594-25.765a2.5 2.5 0 0 1 2.461-2.939h21.712a2.5 2.5 0 0 1 2.461 2.939l-4.59 25.764a5.282 5.282 0 0 1 -5.204 4.358zm-11.394-28.061 4.067 22.826a.285.285 0 0 0 .281.235h7.046a.287.287 0 0 0 .282-.236l4.066-22.825z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "m128 256.025a37.924 37.924 0 0 1 -26.9-11.125l-30.723-30.722a38.077 38.077 0 0 1 -9.5-37.852 2.5 2.5 0 0 1 1.094-1.421c7.984-4.866 36.4-19.178 66.912 1.01a55.375 55.375 0 0 0 31.038 9.563 64.243 64.243 0 0 0 31.953-8.945 2.5 2.5 0 0 1 3.729 1.535 38.319 38.319 0 0 1 -9.977 36.11l-30.726 30.722a37.924 37.924 0 0 1 -26.9 11.125zm-62.6-77.348a33.073 33.073 0 0 0 8.509 31.966l30.722 30.723a33.083 33.083 0 0 0 46.73 0l30.722-30.723a33.278 33.278 0 0 0 9.294-28.1c-10.068 5.265-37.282 16.058-65.261-2.457-27.068-17.917-52.376-6.268-60.716-1.409z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "m150 178a9 9 0 1 1 9-9 9.011 9.011 0 0 1 -9 9zm0-13a4 4 0 1 0 4 4 4 4 0 0 0 -4-4z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "m113 213a13 13 0 1 1 13-13 13.015 13.015 0 0 1 -13 13zm0-21a8 8 0 1 0 8 8 8.009 8.009 0 0 0 -8-8z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "m137.5 158a6.5 6.5 0 1 1 6.5-6.5 6.508 6.508 0 0 1 -6.5 6.5zm0-8a1.5 1.5 0 1 0 1.5 1.5 1.5 1.5 0 0 0 -1.5-1.5z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "m139 220a8 8 0 1 1 8-8 8.009 8.009 0 0 1 -8 8zm0-11a3 3 0 1 0 3 3 3 3 0 0 0 -3-3z"
});

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 512,
  viewBox: "0 0 256 256",
  width: 512
}, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27);

export default __webpack_public_path__ + "static/media/killPotion.15648a47.svg";
export { SvgComponent as ReactComponent };